const PRODUCTS = [
  {
    name: 'NEDZA VPN',
    tagline: 'Secure. Private. Fast.',
    category: 'Privacy & Security',
    description:
      'Military-grade encryption that shields your online activity from trackers, hackers, and surveillance. Connect to servers worldwide with zero-log policy and blazing-fast speeds.',
    highlights: ['256-bit AES Encryption', 'Zero-Log Policy', 'Global Server Network', 'Kill Switch Protection'],
    icon: 'ri-shield-keyhole-line',
    image: 'https://public.readdy.ai/ai/img_res/616258d8da39db231dcc3647aee0ac69.jpg',
    accent: 'from-slate-900 to-slate-800',
    badge: 'bg-emerald-500',
  },
  {
    name: 'NEDZA Cleaner',
    tagline: 'Clean. Fast. Optimized.',
    category: 'Performance & Optimization',
    description:
      'Reclaim your iPhone\'s full potential. Intelligently detects junk files, duplicate photos, and memory hogs — freeing up gigabytes of storage with a single tap.',
    highlights: ['Smart Junk Detection', 'Duplicate Photo Finder', 'Memory Optimizer', 'Battery Health Monitor'],
    icon: 'ri-speed-up-line',
    image: 'https://readdy.ai/api/search-image?query=clean%20iOS%20cleaner%20app%20interface%20on%20iPhone%20mockup%2C%20light%20theme%20with%20performance%20graphs%20and%20storage%20visualization%2C%20modern%20minimalist%20design%2C%20optimization%20dashboard%2C%20soft%20white%20and%20green%20color%20palette&width=500&height=600&seq=cleaner-product-001&orientation=portrait',
    accent: 'from-gray-900 to-gray-800',
    badge: 'bg-sky-500',
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="py-28 md:py-36 bg-gray-950">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <span className="inline-block text-xs font-semibold tracking-widest uppercase text-emerald-400 border border-emerald-700/50 rounded-full px-4 py-1.5 bg-emerald-900/30 mb-5">
              Our Solutions
            </span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-white leading-tight">
              Premium iOS Products
            </h2>
          </div>
          <p className="text-gray-400 text-base max-w-sm leading-relaxed">
            Two flagship applications designed to protect and optimize your iOS experience.
          </p>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {PRODUCTS.map((product) => (
            <div
              key={product.name}
              className={`relative rounded-2xl bg-gradient-to-br ${product.accent} overflow-hidden group`}
            >
              {/* Top content */}
              <div className="p-8 md:p-10">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/10">
                    <i className={`${product.icon} text-white text-xl`}></i>
                  </div>
                  <span className={`text-xs font-semibold text-white px-3 py-1 rounded-full ${product.badge}`}>
                    {product.category}
                  </span>
                </div>

                <h3 className="text-2xl md:text-3xl font-extrabold text-white mb-2">{product.name}</h3>
                <p className="text-emerald-400 text-sm font-semibold tracking-wide mb-4">{product.tagline}</p>
                <p className="text-gray-300 text-sm leading-relaxed mb-7">{product.description}</p>

                {/* Highlights */}
                <ul className="grid grid-cols-2 gap-2">
                  {product.highlights.map((h) => (
                    <li key={h} className="flex items-center gap-2 text-gray-300 text-xs">
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-check-line text-emerald-400 text-sm"></i>
                      </span>
                      {h}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Product Image */}
              <div className="relative h-64 md:h-72 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
